import { NextPage } from 'next';
import { GetServerSideProps } from 'next';
import Podcasts from '@/components/screens/podcasts/Podcasts';
import { IPodcastPage } from '@/interfaces/podcastsPage.interface';
import { API_URL, BOOKS_FOR_PAGE } from '@/helpers/variables';

interface IPodcastsPageProps {
  books: IPodcastPage;
}

const PodcastsPage: NextPage<IPodcastsPageProps> = ({ books }) => {
  return <Podcasts books={books} />;
};

export const getServerSideProps: GetServerSideProps = async () => {
  const res = await fetch(`${API_URL}satellite/podcast/podcast?page=1&page_size=${BOOKS_FOR_PAGE}&sort_field=rating&sort_reversed=true`);
  const books = await res.json();

  // Check Fetched Data Error
  if (books?.data && books?.data.length === 0) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      books,
    },
  };
};

export default PodcastsPage;
